import React from "react";
import { Badge, BadgeVariant, MantineColor, useMantineTheme } from "@mantine/core";
import classes from "./styles.module.css";

interface ITag {
  color: MantineColor;
  name: string;
  variant?: BadgeVariant;
  useHover?: boolean;
}

function Tag({ color, name, variant, useHover = false }: ITag): React.JSX.Element {
  const theme = useMantineTheme();
  const badgeProps = color.startsWith("#") ? { style: { border: `${color} 1px solid`, color }, color: undefined } : { color };

  let backgroundColor = "";
  if (color.includes(".")) {
    const [colorName, shadeStr] = color.split(".");
    const shade = parseInt(shadeStr, 10);
    backgroundColor = theme.colors?.[colorName]?.[shade] || theme.colors.indigo[5];
  } else if (!color.startsWith("#")) {
    backgroundColor = theme.colors?.[color]?.[5] || theme.colors.indigo[5];
  } else {
    backgroundColor = color;
  }

  const hoverStyle = useHover ? ({ "--tag-hover-bg": backgroundColor } as React.CSSProperties) : undefined;
  const mergedStyle = { ...(badgeProps.style || {}), ...(hoverStyle || {}) };

  return (
    <Badge
      {...badgeProps}
      style={Object.keys(mergedStyle).length ? mergedStyle : undefined}
      variant={variant ? variant : "outline"}
      size="md"
      radius="sm"
      styles={{ label: { overflow: "visible" } }}
      className={useHover ? classes.hover : ""}>
      {name}
    </Badge>
  );
}

export { Tag };
